<template>
  <div>
    <!-- 小于750px -->
    <div class="centent-mobile">
      <header>
        <img @click="goBack" class="go-back" src="@/assets/img/go_back.png" alt="" />
        <span class="info">{{
          $t("questionnaireItem.questionnaireInfo")
        }}</span>
      </header>
      <div class="main">
        <div class="questionnaireInfo-name">{{ questionnaireInfo.name }}</div>
        <div class="card">
          <div class="card-top">
            <div>{{ $t("questionnaireItem.goldNumber") }}：</div>
            <span>{{ questionnaireInfo.points }}</span>
            <img src="@/assets/img/species.png" alt="" />
          </div>
          <div class="card-bottom">
            <div>
              <span class="facility-value">{{ $t("questionnaireItem.facilityValue") }}：</span>
              <span>{{ questionnaireInfo.ir }}%</span>
            </div>
            <div>
              <span>{{ $t("questionnaireItem.duration") }}：</span>
              <span>{{ questionnaireInfo.loi
              }}{{ $t("questionnaireItem.minute") }}</span>
            </div>
          </div>
        </div>
        <div class="requirements">
          {{ $t("questionnaireItem.questionnaireRequirements") }}
        </div>
        <div class="describe" v-html="questionnaireInfo.describe"></div>

        <div class="reminder">
          <div>{{ $t("questionnaireItem.reminder") }}：</div>
          <p>{{ $t("questionnaireItem.text1") }}</p>
          <p>{{ $t("questionnaireItem.text2") }}</p>
          <p>{{ $t("questionnaireItem.text3") }}</p>
        </div>
      </div>

      <footer>
        <button @click="getIntoQuestionnaire">
          {{ $t("questionnaireItem.inQuestionnaire") }}
        </button>
      </footer>
    </div>
    <!-- 大于或等于750px -->
    <div class="centent-pc">
      <div class="pc-top">
        <span> {{ $t("questionnaireItem.dailyTasks") }}</span>
        <img class="go-back" src="@/assets/img/arrowhead.png" alt="" />
        <span> {{ questionnaireInfo.number }}</span>
      </div>
      <div class="pc-main">
        <div class="pc-main-left">
          <div class="pc-main-left-top pc-card">
            <div class="questionnaire-info">
              <div class="name pc-font-bold">
                <div>{{ $t("questionnaireItem.questionnaireName") }}</div>
                <div>
                  {{ questionnaireInfo.name
                  }}<span class="platform">({{ questionnaireInfo.platform }})</span>
                </div>
              </div>
              <div class="increase-number">
                <div class="title">{{ $t("questionnaireItem.goldNumber") }}</div>
                <div class="increase big-font">
                  {{ questionnaireInfo.points }}
                  <span class="jinbi">{{ $t("questionnaireItem.gold") }}</span>
                </div>
              </div>
              <div class="increase-other">
                <div class="title">{{ $t("questionnaireItem.questionnaireDuration") }}</div>
                <span class="increase2">
                  {{ $t("questionnaireItem.about")
                  }} <span class="big-font">{{ questionnaireInfo.loi }}</span> {{ $t("questionnaireItem.minute") }}</span>
              </div>
              <div class="increase-other">
                <div class="title">{{ $t("questionnaireItem.passRate") }}</div>
                <span class="increase3 big-font">
                  {{ questionnaireInfo.ir }}%</span>
              </div>
              <div class="increase-other">
                <div class="title">{{ $t("questionnaireItem.rewardMethod") }}</div>
                <span class="increase2">
                  {{ questionnaireInfo.realtime }}</span>
              </div>
            </div>
            <div class="begin-answer">
              <button @click="getIntoQuestionnaire">
                {{ $t("questionnaireItem.startAnsweringQuestions") }}
              </button>
            </div>
          </div>
          <div class="questionnaire-ask pc-card">
            <div class="pc-font-bold">
              {{ $t("questionnaireItem.questionnaireRequirements") }}：
            </div>
            <div class="describe" v-html="questionnaireInfo.describe"></div>
          </div>
        </div>
        <div class="pc-main-right pc-card">
          <div class="pc-font-bold">
            {{ $t("questionnaireItem.reminder") }}：
          </div>
          <div class="attention">
            <p>{{ $t("questionnaireItem.text1") }}</p>
            <p>
              {{ $t("questionnaireItem.text2") }}
            </p>
            <p>{{ $t("questionnaireItem.text3") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { surveys } from "@/api/api.js";
export default {
  data() {
    return {
      questionnaireInfo: {
        name: "日常S调查18期",
        points: 300,
        realtime: "金币奖励",
        loi: "10",
        ir: "30",
        describe:
          " <p>1、在回答问卷过程中，请不要中断，避免失去获得金币的机会。</p><p>2、回答过程中请不要点击浏览器的返回按钮。(请确认内容后点击“开始回答问卷”之后请勿返回当前页面)</p><p>3、部分问卷在国外而导致问卷加载缓慢时，请耐心等待。</p>",
        number: "12321",
        platform: "仅支持pc端答题",
      },
    };
  },
  created() {
    console.log(123, this.$route.query.encryptId);
    if (this.$route.query.encryptId) {
      surveys({
        id: this.$route.query.encryptId,
      }).then((res) => {
        console.log(123, res);
        this.questionnaireInfo = res.data;
      });
    }
    // 判断是否是全屏显示
     setTimeout(() => {
      if (
        localStorage.getItem("questionnaireItem") == 0 ||
        !localStorage.getItem("questionnaireItem")
      ) {
        localStorage.setItem("questionnaireItem", 1);
        //this.$router.go(0);
      }
    }, 100);
  },
    destroyed() {
    // 判断是否是全屏显示
    localStorage.setItem("questionnaireItem", 0);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getIntoQuestionnaire() {
      window.location.href =
        "http://www.weopinions.com" + this.questionnaireInfo.surveyLink;
    },
  },
};
</script>
<style scoped>
.centent-mobile,
.centent-pc {
  font-family:'Nunito', sans-serif
}

@media only screen and (max-width: 751px) {
  .centent-mobile {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    /*color: #fff;*/
    background-color: #f8f8f8;
  }

  .centent-pc {
    display: none;
  }

  header {
    width: 100%;
    height: 104px;
    line-height: 104px;
    font-size: 32px;
    font-weight: 400;
    position: relative;
    background-color: #489ed7;
  }

  .go-back {
    width: 48px;
    height: 48px;
    position: absolute;
    left: 24px;
    top: 50%;
    transform: translateY(-50%);
  }

  header>.info {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
  }

  .main {
    padding-bottom: 120px;
  }

  .questionnaireInfo-name {
    color: #232323;
    font-weight: 700;
    font-size: 32px;
    margin-top: 40px;
    margin-left: 30px;
  }

  .card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: calc(100% - 108px);
    height: 108px;
    background: #ffffff;
    border-radius: 16px;
    opacity: 1;
    margin-left: 24px;
    padding: 20px 24px;
    margin-top: 42px;
    color: #000;
    font-size: 28px;
    font-weight: 400;
  }

  .card-top {
    display: flex;
    line-height: 37px;
  }

  .card-top>span {
    color: #f9bd9d;
    margin-left: 10px;
  }

  .card-top>img {
    width: 37px;
    height: 37px;
  }

  .card-bottom {
    display: flex;
    justify-content: space-between;
  }

  .requirements {
    font-size: 28px;
    margin-left: 30px;
    margin-top: 42px;
    color: #000;
  }

  .describe {
    margin-top: 48px;
    width: calc(100% - 72px);
    margin-left: 30px;
  }

  .reminder {
    width: calc(100% - 60px);
    margin-left: 30px;
    color: #e8626a;
    font-size: 24px;
    margin-top: 100px;
  }

  .reminder div {
    margin-bottom: 8px;
    line-height: 1.75;
  }

  .reminder p {
    margin-bottom: 8px;
    line-height: 1.75;
  }

  footer {
    width: 100%;
  }

  footer>button {
    width: calc(100% - 108px);
    height: 60px;
    box-shadow: 0px 2px 8px 1px rgba(255, 161, 0, 0.63);
    opacity: 1;
    padding: 0;
    margin: 0;
    margin-top: 90px;
    margin-bottom: 30px;
    font-size: 32px;
    border: none;
    background-color: #fbc260;
    color: #fff;
    border-radius: 60px;
    letter-spacing: 6px;
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
}

@media only screen and (max-width: 563px) {
  header {
    height: 78px;
    line-height: 78px;
    font-size: 24px;
  }

  .go-back {
    width: 36px;
    height: 36px;
    left: 18px;
  }

  .main {
    padding-bottom: 90px;
  }

  .questionnaireInfo-name {
    font-size: 24px;
    margin-top: 30px;
    margin-left: 22.5px;
  }

  .card {
    width: calc(100% - 81px);
    height: 81px;
    border-radius: 12px;
    margin-left: 18px;
    padding: 15px 18px;
    margin-top: 15px;
    font-size: 21px;
  }

  .card-top {
    line-height: 28px;
  }

  .card-top>span {
    margin-left: 7.5px;
  }

  .card-top>img {
    width: 28px;
    height: 28px;
  }

  .requirements {
    font-size: 21px;
    margin-left: 22.5px;
    margin-top: 31.5px;
    color: #000;
  }

  .describe {
    margin-top: 36px;
    width: calc(100% - 54px);
    margin-left: 22.5px;
  }

  .reminder {
    width: calc(100% - 45px);
    margin-left: 22.5px;
    font-size: 18px;
    margin-top: 56.25px;
  }

  footer>button {
    width: calc(100% - 81px);
    height: 45px;
    margin-top: 67.5px;
    margin-bottom: 22.5px;
    font-size: 24px;
    border-radius: 45px;
    letter-spacing: 4.5px;
    bottom: 15px;
  }
}

@media only screen and (max-width: 376px) {
  header {
    height: 52px;
    line-height: 52px;
    font-size: 16px;
  }

  .go-back {
    width: 24px;
    height: 24px;
    left: 12px;
  }

  .main {
    padding-bottom: 60px;
  }

  .questionnaireInfo-name {
    font-size: 16px;
    margin-top: 20px;
    margin-left: 15px;
  }

  .card {
    width: calc(100% - 54px);
    height: 54px;
    border-radius: 8px;
    margin-left: 12px;
    padding: 10px 12px;
    margin-top: 21px;
    font-size: 14px;
  }

  .card-top {
    line-height: 19px;
  }

  .card-top>span {
    margin-left: 5px;
  }

  .card-top>img {
    width: 19px;
    height: 19px;
  }

  .requirements {
    font-size: 14px;
    margin-left: 15px;
    margin-top: 21px;
  }

  .describe {
    margin-top: 24px;
    width: calc(100% - 36px);
    margin-left: 15px;
  }

  .reminder {
    width: calc(100% - 30px);
    margin-left: 15px;
    font-size: 12px;
    margin-top: 50px;
  }

  footer>button {
    width: calc(100% - 54px);
    height: 30px;
    margin-top: 45px;
    margin-bottom: 15px;
    font-size: 16px;
    border-radius: 30px;
    letter-spacing: 3px;
    bottom: 10px;
  }
}

@media only screen and (max-width: 251px) {
  .centent-mobile {
    min-width: 250px;
    width: 250px;
  }

  footer>button {
    width: 150px;
    height: 20px;
    margin-top: 30px;
    margin-bottom: 10px;
    font-size: 10px;
    border-radius: 20px;
    letter-spacing: 2px;
    bottom: 6px;
  }
}

@media only screen and (min-width: 751px) {
  .centent-mobile {
    display: none;
  }

  .centent-pc {
    display: block;
    width: calc(100% - 80px);
    padding: 30px 40px;
    background-color: #e5e5e5;
    min-height: calc(100vh - 60px);
  }

  .pc-top {
    width: calc(100% - 30px);
    height: 62px;
    padding-left: 30px;
    background-color: #fefeff;
    display: flex;
    align-items: center;
    color: #999999;
    font-size: 16px;
  }

  .pc-top>img {
    width: 24px;
    height: 24px;
    margin: 0 8px;
  }

  .pc-main {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    width: 100%;
  }

  .pc-card {
    background-color: #fefeff;
    border-radius: 8px;
  }

  .pc-font-bold {
    font-size: 16px;
    font-weight: 600;
  }

  .big-font {
    font-size: 18px;
    font-weight: 600;
    color: #ffa201;
  }

  /* 主体左侧 */
  .pc-main-left {
    display: flex;
    flex-direction: column;
    width: 68.3%;
  }

  .pc-main-left-top {
    display: flex;
    justify-content: space-between;
    padding: 30px;
    min-height: 202px;
  }

  .questionnaire-info {
    display: flex;
    flex-direction: column;
  }

  /* 问卷名称 */
  .questionnaire-info>.name {
    display: flex;
  }

  .questionnaire-info>.name>div {
    margin-right: 50px;
  }

  .questionnaire-info .platform {
    font-size: 14px;
    color: #999999;
    margin-left: 5px;
  }

  /* 金币数量 */
  .increase-number {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 40px;
  }

  .increase {
    margin-left: 58px;
  }

  .jinbi {
    font-size: 12px;
    margin-left: 2px;
    color: #ffa201;
  }

  /* 奖励方式和时长 */
  .increase-other {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 20px;
  }

  .increase2 {
    margin-left: 58px;
  }

  .increase3 {
    margin-left: 58px;
  }

  .begin-answer>button {
    padding: 0;
    margin: 0;
    border: none;
    width: 120px;
    height: 34px;
    background: #ffa100;
    font-size: 12px;
    color: #fff;
    box-shadow: 0px 2px 8px 1px rgba(255, 161, 0, 0.63);
    border-radius: 26px;
    margin-top: 18px;
    opacity: 1;
    cursor: pointer;
  }

  .title {
    width: 120px;
  }

  /* 问卷要求 */
  .questionnaire-ask {
    margin-top: 20px;
    padding: 30px;
    min-height: 122px;
    height: 100%;
  }

  .describe {
    margin-top: 16px;
  }

  /* 主体右侧 */
  .pc-main-right {
    width: calc(30% - 46px);
    padding: 26px 22px 0 24px;
  }

  .attention {
    width: calc(100% - 34px);
    min-height: 116px;
    background: #ffeced;
    border-radius: 8px;
    opacity: 1;
    margin-top: 17px;
    padding: 26px 18px 26px 16px;
    font-size: 14px;
    color: #333333;
    line-height: 24px;
    margin-bottom: 20px;
  }
}

@media only screen and (min-width: 1131px) {
  .begin-answer>button {
    margin-right: 56px;
  }
}

@media only screen and (min-width: 2000px) {
  .centent-pc {
    display: block;
    margin: 0 auto;
    max-width: 2000px;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/pages/questionnaireItem/QuestionnaireItem.vue